<template>
  <aside class="drawer">
    <div class="wrapper">
      <header>
        <h2>
          {{
            action === "add" ? "Personaliza tu plantilla" : `Editar ${getNameByType(item?.type)}`
          }}
        </h2>

        <a-button type="text" class="button" @click="handleClose">
          <CloseOutlined />
        </a-button>
      </header>

      <CustomScrollbar height="calc(100% - 45px)">
        <div class="body">
          <ItemsToAddList v-if="action === 'add'" ref="pickerRef" />

          <component
            v-if="action === 'edit'"
            ref="settingsRef"
            :is="componentToUse"
            :item="cloneDeep(item)"
            :template="template"
          />
        </div>
      </CustomScrollbar>
    </div>

    <footer>
      <a-button @click="handleClose">Ocultar</a-button>
      <a-button
        type="primary"
        @click="handleSave"
        :loading="saving"
        :disabled="action === 'add' ? !pickerRef?.selected : false"
      >
        {{ action === "add" ? "Agregar elemento" : "Guardar elemento" }}
      </a-button>
    </footer>
  </aside>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { cloneDeep } from "lodash";

import {
  ItemType,
  ItemTypeMapper,
  TemplateItem,
  TemplateItemOption,
  TextItem,
} from "@/@types/flows/emailTemplates/items";
import { ItemNameByType } from "@/app/flows/emailTemplates/utils/texts";
import { TemplateItemsManager } from "@/app/flows/emailTemplates/utils/TemplateItemsManager";
import { Template } from "@/@types/flows/emailTemplates";

import ItemsToAddList from "@/app/flows/emailTemplates/components/lists/ItemsToAddList.vue";
import TextForm from "@/app/flows/emailTemplates/components/sections/ConfigDrawer/content/TextForm.vue";
import ButtonForm from "@/app/flows/emailTemplates/components/sections/ConfigDrawer/content/ButtonForm.vue";
import ImageForm from "@/app/flows/emailTemplates/components/sections/ConfigDrawer/content/ImageForm.vue";
import HtmlForm from "@/app/flows/emailTemplates/components/sections/ConfigDrawer/content/HtmlForm.vue";
import FooterForm from "@/app/flows/emailTemplates/components/sections/ConfigDrawer/content/FooterForm.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

import HslToHex from "@/app/shared/utils/hslToHex";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FormByType: Record<ItemType, any> = {
  [ItemType.Text]: TextForm,
  [ItemType.Button]: ButtonForm,
  [ItemType.Image]: ImageForm,
  [ItemType.Html]: HtmlForm,
  [ItemType.Footer]: FooterForm,
};

const props = defineProps<{
  action: "add" | "edit";
  item: TemplateItem | undefined;
  saving: boolean;
  template: Template;
}>();

const emit = defineEmits<{
  close: [];
  add: [option: TemplateItemOption];
  edited: [];
}>();

const handleClose = () => emit("close");

const pickerRef = ref<InstanceType<typeof ItemsToAddList>>();
const settingsRef = ref<{
  getValidatedFormState: () => Promise<Omit<ItemTypeMapper[ItemType], "id" | "type">>;
}>();

const componentToUse = computed(() => (props.item ? FormByType[props.item.type] : null));

const getNameByType = (type: ItemType | undefined) => {
  if (!type) return "desconocido";

  return ItemNameByType[type];
};

const hslToHex = new HslToHex();

const handleSave = async () => {
  if (props.action === "add") {
    if (!pickerRef.value?.selected) return;

    emit("add", pickerRef.value.selected);
  }

  if (props.action === "edit") {
    if (!settingsRef.value) return;
    if (!props.item) return;

    const formState = await settingsRef.value.getValidatedFormState();

    // if (props.item.type == ItemType.Text) {
    //   formState.text = hslToHex.convertHslToHex(formState.text);
    // }
    console.log(formState, "form state");
    TemplateItemsManager.editElement(props.item.id, formState);

    emit("edited");
  }
};
</script>

<style scoped lang="sass">
.drawer
  display: flex
  flex: 1 1 auto
  max-width: 650px
  flex-direction: column
  justify-content: space-between
  background: #FFFFFF
  box-shadow: -4px 0px 10px rgba(0, 0, 0, 0.15)
  border-radius: 4px
  overflow: hidden
  // height: calc(100vh - 118px)
  height: calc(100vh - 155px)

.wrapper
  height: calc(100% - 57px)

h2
  color: $gray-9
  font-weight: 600
  font-size: 16px
  margin: 0
  line-height: 24px

.button
  padding: 0 5px
  border-radius: 4px
  height: 24px
  font-size: 16px

header
  border-bottom: 1px solid $gray-4
  padding: 10px 20px
  display: flex
  align-items: center
  justify-content: space-between

.body
  padding: 16px 24px

footer
  border-top: 1px solid $gray-4
  padding: 12px 16px
  display: flex
  align-items: center
  justify-content: flex-end
  gap: 8px
</style>
